import { store } from '../store';
import { logout } from '../store/slices/authSlice';
import toast from 'react-hot-toast';

export function handleSessionExpired() {
    toast.error('Session expired. Please log in again.');
    store.dispatch(logout());
    // setTimeout(() => {
    //     window.location.href = '/login';
    // }, 1500);
}
